/* Native product forms remain functional without JavaScript. */
(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-kuzu-product]').forEach((root) => {
      if (root.dataset.commerceReady) return;
      root.dataset.commerceReady = 'true';
      const select = root.querySelector('select[name="id"]');
      const price = root.querySelector('[data-variant-price]');
      const submit = root.querySelector('.kuzu-product__submit');
      if (select) select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        if (price) price.textContent = option.dataset.price;
        if (submit) {
          const available = option.dataset.available === 'true';
          submit.disabled = !available;
          submit.textContent = available ? submit.dataset.addLabel : submit.dataset.soldLabel;
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', select.value);
        window.history.replaceState({}, '', url);
      });
    });
    scope.querySelectorAll('.kuzu-mobile-nav').forEach((menu) => {
      if (menu.dataset.menuReady) return;
      menu.dataset.menuReady = 'true';
      const summary = menu.querySelector('summary');
      menu.addEventListener('toggle', () => summary.setAttribute('aria-label', menu.open ? 'Close menu' : 'Open menu'));
      menu.addEventListener('click', (event) => {
        if (event.target.closest('a')) menu.open = false;
      });
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          menu.open = false;
          menu.querySelector('summary').focus();
        }
      });
      menu.addEventListener('focusout', (event) => {
        if (event.relatedTarget && !menu.contains(event.relatedTarget)) menu.open = false;
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('pointerdown', (event) => {
    document.querySelectorAll('.kuzu-mobile-nav[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
})();
